// frontend/src/components/StatusExistPill.tsx
import React from "react";
import { Badge } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";

export const StatusExistPill: React.FC<{ exists: boolean; label?: string }> = ({ exists, label }) => {
  if (exists) {
    return (
      <Badge leftSection={<IconCheck size={14} />} color="green" variant="light">
        {label ?? "Finnes"}
      </Badge>
    );
  }
  return (
    <Badge leftSection={<IconX size={14} />} color="red" variant="light">
      {label ?? "Mangler"}
    </Badge>
  );
};
